import { Box, type ColorUnion, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import { ColoursTypes } from 'modules/engagement_insights/lib/widget'

const topLeftEllipseStyle = {
  position: 'absolute',
  width: '24%',
  height: '89px',
  top: '-40px',
  left: '-18px',
  opacity: '0.3',
  filter: 'blur(47px)',
  willChange: 'filter',
}

const topRightEllipseStyle = {
  position: 'absolute',
  width: '88.5%',
  height: '121px',
  top: '-59px',
  left: '12px',
  opacity: '0.3',
  filter: 'blur(89px)',
  willChange: 'filter',
}

const ellipseStyles = {
  green: [
    {
      ...topLeftEllipseStyle,
      background: '#B2FE11',
    },
    {
      ...topRightEllipseStyle,
      background: '#68CC45',
    },
  ],
  yellow: [
    {
      ...topLeftEllipseStyle,
      background: '#F5BA58',
    },
    {
      ...topRightEllipseStyle,
      background: '#F5BA58',
    },
  ],
  red: [
    {
      ...topLeftEllipseStyle,
      background: '#C51B3E',
    },
    {
      ...topRightEllipseStyle,
      background: '#FF869E',
    },
  ],
}

interface WidgetHeaderProps {
  loading: boolean
  showEllipse: boolean | undefined
  showTag?: boolean
  tagColor: ColorUnion | undefined
  tagLabel: string | undefined
  title: string
  ellipseGradientColor: ColoursTypes | undefined
}

const WidgetHeader = ({
  loading,
  showEllipse = false,
  showTag = true,
  tagColor,
  tagLabel,
  title,
  ellipseGradientColor,
}: WidgetHeaderProps) => {
  return (
    <>
      {showEllipse && ellipseGradientColor && (
        <>
          <Box style={ellipseStyles[ellipseGradientColor][0]} />
          <Box style={ellipseStyles[ellipseGradientColor][1]} />
        </>
      )}
      <Box
        style={{ paddingBottom: '20px', zIndex: '1' }}
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        <Text htmlTag="p" weight="semibold" color="grey1000" size="400">
          {title}
        </Text>
        <Box flexDirection="row">
          {!loading && showTag && !!tagLabel && (
            <Box paddingRight="s16">
              <Tag capitalize type={tagColor}>
                {tagLabel}
              </Tag>
            </Box>
          )}
          <Icon.Medium icon="arrow-right" />
        </Box>
      </Box>
    </>
  )
}

export default WidgetHeader
